export const getReactSelectStyles = (theme: string) => ({
  control: (provided: Record<string, unknown>, state: { isFocused: boolean }) => ({
    ...provided,
    backgroundColor: "transparent",
    borderColor: state.isFocused
      ? "#0B75C2"
      : theme === "dark"
      ? "#4B5563"
      : "#d1d5db",
    boxShadow: state.isFocused ? "0 0 0 1.5px #0B75C2" : "none",
    minHeight: "48px",
    borderRadius: "0.75rem",
    fontSize: "15px",
    color: theme === "dark" ? "#D1D5DB" : "#374151",
    outline: "none",
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean; isFocused: boolean }
  ) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? theme === "dark"
        ? "#192025"
        : "#E8F3FC"
      : state.isFocused
      ? theme === "dark"
        ? "#232B36"
        : "#F3F4F6"
      : theme === "dark"
      ? "#1F2B36"
      : "#fff",
    color: theme === "dark" ? "#D1D5DB" : "#1F2937",
    fontSize: "15px",
    padding: "10px 16px",
    cursor: "pointer",
  }),
  singleValue: (provided: Record<string, unknown>) => ({
    ...provided,
    color: theme === "dark" ? "#D1D5DB" : "#374151",
    fontWeight: 500,
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    borderRadius: "0.75rem",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    zIndex: 40,
    backgroundColor: theme === "dark" ? "#1F2B36" : "#fff",
  }),
  menuPortal: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 40,
  }),
  input: (provided: Record<string, unknown>) => ({
    ...provided,
    color: theme === "dark" ? "#D1D5DB" : "#374151",
    fontSize: "15px",
  }),
  placeholder: (provided: Record<string, unknown>) => ({
    ...provided,
    color: "#6B7280",
    fontSize: "15px",
  }),
});
